export default "__VITE_ASSET__Cu_ClzkL__"